import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { Layout } from './layout/layout';
import { Bonds } from './layout/bonds/bonds';
import { BondListingRouteData } from './layout/bonds/bonds.types';
import { Catalog } from './layout/catalog/catalog';
import { BondDocumentationComponent } from './layout/catalog/bond-documentation/bond-documentation';
import { BondFormatComponent } from './layout/catalog/bond-format/bond-format';
import { BondListingComponent } from './layout/catalog/bond-listing/bond-listing';
import { BondProceedComponent } from './layout/catalog/bond-proceed/bond-proceed';
import { BondProceedSubtypeComponent } from './layout/catalog/bond-proceed-subtype/bond-proceed-subtype';
import { BondTypeComponent } from './layout/catalog/bond-type/bond-type';
import { Investor } from './layout/catalog/investor/investor';
import { InvoiceConceptComponent } from './layout/catalog/invoice-concept/invoice-concept';
import { VendorTypeComponent } from './layout/catalog/vendor-type/vendor-type';
import { InvestorTypeComponent } from './layout/catalog/investor-type/investor-type';
import { CountryComponent } from './layout/catalog/country/country';
import { NonNamedDealerComponent } from './layout/catalog/non-named-dealer/non-named-dealer';
import { RegionComponent } from './layout/catalog/region/region';
import { SwapActionTypeComponent } from './layout/catalog/swap-action-type/swap-action-type';
import { SwapPurposeComponent } from './layout/catalog/swap-purpose/swap-purpose';
import { SwapPurposeSubtypeComponent } from './layout/catalog/swap-purpose-subtype/swap-purpose-subtype';
import { ReofferBmkComponent } from './layout/catalog/reoffer-bmk/reoffer-bmk';
import { SwapFeeTypeComponent } from './layout/catalog/swap-fee-type/swap-fee-type';
import { InvestorGroupComponent } from './layout/catalog/investor-group/investor-group';
import { FridaConfigComponent } from './layout/catalog/frida-config/frida-config';
import { BondsCloningComponent } from './layout/catalog/bonds-cloning/bonds-cloning';
import { SwapsCloningComponent } from './layout/catalog/swaps-cloning/swaps-cloning';
import { VendorCatalogComponent } from './layout/catalog/vendor/vendor';
import { VendorDetailComponent } from './layout/catalog/vendor-detail/vendor-detail';
import { Dashboard } from './layout/dashboard/dashboard';
import { Swaps } from './layout/swaps/swaps';
import { BondDetail } from './layout/bonds/bond-detail/bond-detail';
import { BondDefinition } from './layout/bonds/bond-definition/bond-definition';
import { SwapDetail } from './layout/swaps/swap-detail/swap-detail';
import { Invoices } from './layout/invoices/invoices';
import { InvoiceCreate } from './layout/invoices/invoice-create/invoice-create';
import { InvoiceDetail } from './layout/invoices/invoice-detail/invoice-detail';
import { UnauthorizedComponent } from './auth/unauthorized/unauthorized';
import { authAccessChildGuard, authAccessGuard } from './auth/auth-access.guard';
import { AuthCallbackComponent } from './auth/auth-callback/auth-callback';

const bondListingData = (label: string, view?: BondListingRouteData['view']): BondListingRouteData => ({
    label,
    view,
});

export const routes: Routes = [
    { path: 'auth', component: AuthCallbackComponent },
    { path: 'unauthorized', component: UnauthorizedComponent },
    {
        path: '',
        component: Layout,
        canActivate: [MsalGuard, authAccessGuard],
        canActivateChild: [MsalGuard, authAccessChildGuard],
        children: [
            { path: '', component: Dashboard },
            { path: 'swaps', component: Swaps },
            { path: 'swap-detail/:tradeId', component: SwapDetail },
            { path: 'bonds', component: Bonds, data: bondListingData('Bonds') },
            { path: 'discount-notes', component: Bonds, data: bondListingData('Discount Notes', 'cdn') },
            { path: 'called-bonds', component: Bonds, data: bondListingData('Called Bonds', 'call') },
            { path: 'repurchased-bonds', component: Bonds, data: bondListingData('Repurchased Bonds', 'repurchase') },
            { path: 'bond-detail/:tradeId', component: BondDetail },
            { path: 'bonds/:tradeId', component: BondDetail },
            { path: 'bond-definition/:securityId', component: BondDefinition },
            { path: 'invoices', component: Invoices },
            { path: 'invoices/create', component: InvoiceCreate },
            { path: 'invoices/:invoiceId', component: InvoiceDetail },
            { path: 'catalogs', component: Catalog },
            { path: 'catalogs/bond-documentation', component: BondDocumentationComponent },
            { path: 'catalogs/bond-format', component: BondFormatComponent },
            { path: 'catalogs/bond-listing', component: BondListingComponent },
            { path: 'catalogs/bond-proceed', component: BondProceedComponent },
            { path: 'catalogs/bond-proceed-subtype', component: BondProceedSubtypeComponent },
            { path: 'catalogs/bond-type', component: BondTypeComponent },
            { path: 'catalogs/country', component: CountryComponent },
            { path: 'catalogs/vendor', component: VendorCatalogComponent },
            { path: 'catalogs/vendor/:vendorId', component: VendorDetailComponent },
            { path: 'catalogs/frida-config', component: FridaConfigComponent },
            { path: 'catalogs/investor', component: Investor },
            { path: 'catalogs/investor-group', component: InvestorGroupComponent },
            { path: 'catalogs/investor-type', component: InvestorTypeComponent },
            { path: 'catalogs/invoice-concept', component: InvoiceConceptComponent },
            { path: 'catalogs/vendor-type', component: VendorTypeComponent },
            { path: 'catalogs/non-named-dealer', component: NonNamedDealerComponent },
            { path: 'catalogs/reoffer-bmk', component: ReofferBmkComponent },
            { path: 'catalogs/region', component: RegionComponent },
            { path: 'catalogs/bonds-cloning', component: BondsCloningComponent },
            { path: 'catalogs/swaps-cloning', component: SwapsCloningComponent },
            { path: 'catalogs/swap-action-type', component: SwapActionTypeComponent },
            { path: 'catalogs/swap-fee-type', component: SwapFeeTypeComponent },
            { path: 'catalogs/swap-purpose', component: SwapPurposeComponent },
            { path: 'catalogs/swap-purpose-subtype', component: SwapPurposeSubtypeComponent }
        ]
    }
];
